import { getEnv } from '@xbcb/ui-utils';
import { uiStageToBackendStage } from '@xbcb/ui-types';
import {
  US_HTS_UI_MANAGEMENT_FEATURE,
  usHtsUiManagementFeatureName,
} from '@xbcb/feature-flags';

const { stage } = getEnv();

export const isUsHtsUiManagementEnabled = () =>
  US_HTS_UI_MANAGEMENT_FEATURE.isEnabled(usHtsUiManagementFeatureName, {
    stage: uiStageToBackendStage[stage],
  });
